import { LOGIN, TEMPORARY_LOGIN, LOGIN_RESULT, POSITION_UPDATED,PASSWORD_UPDATED,  BEEN_MODERATED, LOGGED_OUT, LOG_OUT, UPDATE_OWN_AVATAR, USER_DELETED, START_PLAYING, STOP_PLAYING } from './actions'
export const user = (state = { isLogged: false }, action) => {
    const { type, ...data } = action
    switch (type) {
        case LOGIN:
            return {
                ...state,
                ...data,
                isLogging: true,
                isLogged: false
            }
        
        case LOGIN_RESULT:
            return {
                ...state,
                ...data,
                isLogged: !data.error,
                isLogging: false
            }

        case LOG_OUT:
             return {
                 ...state,
                 isLogged:false
             }

        case USER_DELETED: 
             return null;

        case LOGGED_OUT:
             return {
                 is_logged:false,
             }
             
       
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user/index.js